module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "live.com",
  "bol.com.br"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/internet/free_email.js
// module id = 1980
// module chunks = 0